export { default } from "./verify-permission";
